var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.116 6.009A4.793 4.793 0 0 1 15.936 2h-3.438l-.005 13.78a2.892 2.892 0 0 1-2.885 2.782 2.892 2.892 0 0 1-2.89-2.89 2.894 2.894 0 0 1 2.89-2.891c.298 0 .583.049.853.133v-3.51a6.308 6.308 0 0 0-.853-.062 6.336 6.336 0 0 0-6.329 6.33 6.324 6.324 0 0 0 2.702 5.181A6.292 6.292 0 0 0 9.608 22a6.336 6.336 0 0 0 6.329-6.329V8.684c1.348.968 3 1.538 4.784 1.538V6.784c-.96 0-1.855-.286-2.605-.775",
    fill: "#40424C"
  })));
};
export default SvgTiktok;